import React, { Component } from 'react'
import Timesheet, { StatusView, GetProjectTaskNames, TimesheetStatus, TimesheetChange } from 'src/components/timesheet'
import GroupedList, { GroupData, GroupDataItem } from 'src/components/grouped-list'
import SplitterLayout from 'react-splitter-layout'
import 'react-splitter-layout/lib/index.css'
import windowSize, { WindowSizeProps } from 'react-window-size'
import { Divider, Empty, Alert, Row, Col, Card, Spin, Modal, Radio, Select, Input, Button, Dropdown, Menu, Icon, Progress, Tooltip, Checkbox, notification, Badge, Collapse } from 'antd'
import autobind from 'autobind-decorator'
import moment from 'moment'
import HttpService, { formatMessage } from 'src/core/services/http.service'
import FileSaver from 'file-saver'
import { resolve } from 'src/inversify.config'
import { unixEpochToDate, formatCurrency, formatDecimal } from 'src/core/utils/object'
import { CommandResult } from 'src/core/stores/types'
import ContentTitle from 'src/core/ui/content-header'
import { withTranslation, WithTranslation } from 'react-i18next'
import { WrapperProjectTaskEditor } from 'src/components/projecttask-editor'
import { CompanySummary } from 'src/stores/companies-store'
import { ProjectSummary } from 'src/stores/projects-store'
import Tour from 'reactour'
import steps from 'src/components/virtual-tour/virtual-tour-configs'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { DataStore, Query } from 'src/core/stores/dataStore'
import { EmployeeSummary } from 'src/stores/employees-store'
import { IdentityProps, withIdentity } from "src/core/services/authentication"
import EditableTooltip from 'src/components/editable-tooltip/tooltip'
import { CacheProps, TimeType, withCache } from 'src/core/services/cache.service'
const { Option } = Select
import 'src/core/assets/site.less'
import 'src/pages/timesheet/timesheet.less'
import { notificationService, withNotification } from 'src/consumer/notificationContent'
import MyReportsView from 'src/pages/user/my-reports'
import CreateSpecificTimeSheet from 'src/components/createSpecificTimeSheet'
import { TimesheetsStore } from 'src/stores/timesheets-store'
import { withUserProfile, UserProfileProps, companyProfile } from 'src/components/user-profile'
import { extend } from 'lodash'
import CustomLoad from 'src/components/customLoad'
import { RouteComponentProps, withRouter } from 'react-router'
import { successNotification } from 'src/components/systemNotifications/notificationService'
import TimeSheetCalendar from './timesheet-calendar'
import timesheet from 'src/components/timesheet'

const timesheetsStore = new TimesheetsStore()
let Search = Input.Search

interface TimesheetSummary {
  id: string,
  employeeId: string,
  employeeTitle: string,
  fromDate: Date,
  toDate: Date,
  status: TimesheetStatus,
  totalHours: number
  minHours: number
  maxHours: number
}

interface TimesheetTaskEntryItem {
  day: number,
  planned: number,
  hours: number,
  notes: string,
}

export interface TimesheetTaskItem {
  projectTaskId: string,
  projectTaskTitle: string,
  projectId: string,
  projectTitle: string,
  isFavorite: boolean,
  title: string,
  notes: string,
  entries: TimesheetTaskEntryItem[],
  disabledForEmployee: boolean
}

interface TimesheetItem extends TimesheetSummary {
  tasks: TimesheetTaskItem[]
}

interface TimesheetPageProps extends IdentityProps, UserProfileProps, RouteComponentProps, CacheProps {
  handleResetSuccessAddTask?: () => void
  notifications: any
}

interface TimesheetPageStatus {
  timesheets: TimesheetSummary[],
  timesheetIdToIndex: Map<string, number>,
  timesheet: TimesheetItem | undefined,
  companies: any[],
  employeeId: string | undefined,
  employeeTitle: string,
  companyId: string | undefined,
  companyTitle: string,
  currency: string,
  allowCir: boolean,
  allowCii: boolean,
  isBusy: boolean
  isLoading: boolean
  error: string | undefined
  addNewTaskShown: boolean
  canApproveTimesheets: boolean
  isCompanyManager: boolean
  hasRoleAdminOrManager: boolean
  employeeFilter: string
  employeesFilter: string[]
  groups: any[]
  sortDirectionUp: boolean
  sortByDate: boolean
  periodFilter: string[]
  originalGroups: any[]
  incompleteSheets: boolean
  firstEntry: boolean
  projectsFilter: string[]
  allProjects: string[]
  projectIdToSummary: Map<string, ProjectSummary>
  prev1: any
  groupReversed: boolean
  hasEmployeePlan?: boolean
  employeeMinHours: number[]
  employeeMaxHours: number[]
  isTourOpen: boolean
  fromDateTimesheet: number
  toDateTimesheet: number
  pendingTimesheets: number
  statusFilter: string[]
  selectedTimesheetHasChanges: boolean
  selectedNewTimesheet: any
  openConfirmationModal: boolean
  selectedItems: any[]
  errorMessage: string
  showError: boolean
  showBtnCreateTimeSheet: boolean
  companyHoursManager: boolean
  isRoleManager: boolean
  handleSuccessAddTask?: () => void
  handleResetSuccessAddTask?: () => void
  reload: number
  reloadProject: number
  fullReload: number
  forceRender: number
}

interface TimesheetProjectMode {
  projectId: string
  projectTitle: string
  projectTasks: ProjectTaskMode[]
}

interface ProjectTaskMode {
  projectTaskId: string
  projectTaskTitle: string
}
class AddNewTaskView extends Component<any, any> {
  _isMounted = false;
  constructor(props: any) {
    super(props)
    this.state = {
      projectTaskIds: [],
      taskIds: [],
      checkAllTaskByProject: false,
      showError: false,
      companyHoursManager: null,
      selectedProjectTasks: [],
    }
  }

  componentDidMount() {
    this._isMounted = true
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  handleOk = () => {
    if (this.state.projectTaskIds) {
      const projectTasks = this.state.selectedProjectTasks
      this.props.onOk(projectTasks).then((success: number[]) => {
        if (this._isMounted && this.state.projectTaskIds.length != success.length) {
          this.setState({ showError: true, projectTaskIds: success })
        }
      })
    }
  }

  onHandleSelectionProjectTasksChange = (value: TimesheetProjectMode) => {
    this.setState({ selectedProjectTasks: value })
  }

  render() {
    const { t } = this.props
    return <Modal
      visible
      title={this.props.t('Add new project')}
      onOk={() => {
        this.handleOk()
      }}
      okText={t("OK")}
      cancelText={t("Cancel")}
      onCancel={this.props.onCancel}>

      {this.state.showError && <Alert type="error" message={t("Error adding some projects/tasks")} banner />}

      <WrapperProjectTaskEditor
        companyAllowCir={this.props.companyAllowCir}
        companyAllowCii={this.props.companyAllowCii}
        newProjectTaskCallback={(id: any) => {
          if (!this.state.projectTaskIds.includes(id)) {
            this.setState({ projectTaskIds: [...this.state.projectTaskIds, id] })
            this.handleOk()
          }
        }}
        toShow={this.state.projectTaskIds}
        nullable
        placeholder={t('Select a project')}
        companyId={this.props.companyId}
        employeeId={this.props.employeeId}
        includeProjectName
        onChange={(value: any) => this.setState({ projectTaskIds: value })}
        canAddNewProjectsTask={this.props.canAddNewProjectsTask}
        multiple={true}
        fromDate={this.props.fromDate}
        toDate={this.props.toDate}
        onSave={() => {
          if (this.state.projectTaskIds) {
            this.props.onOk(this.state.projectTaskIds)
            this.handleOk()
          }
        }}
        showSelectProject={true}
        isOnlyUser={this.props.isOnlyUser}
        closeAllModal={this.props.onCancel}
        onSelectionChange={this.onHandleSelectionProjectTasksChange}
      />
    </Modal>
  }
}

class TimesheetPage extends Component<TimesheetPageProps & WindowSizeProps & WithTranslation & CacheProps, TimesheetPageStatus> {

    @resolve(HttpService)
    private httpService!: HttpService

    constructor(props: TimesheetPageProps & WindowSizeProps & WithTranslation & CacheProps) {
        super(props)
        this.state = {
            timesheet: undefined,
            employeeId: undefined,
            employeeTitle: "",
            companyTitle: "",
            currency: '\u20AC',
            allowCir: false,
            allowCii: false,
            companies: [],
            companyId: undefined,
            timesheets: [],
            timesheetIdToIndex: new Map(),
            error: undefined,
            isBusy: true,
            addNewTaskShown: false,
            canApproveTimesheets: false,
            isCompanyManager: false,
            hasRoleAdminOrManager: false,
            employeeFilter: '',
            employeesFilter: [],
            groups: [],
            sortDirectionUp: false,
            groupReversed: false,
            sortByDate: true,
            periodFilter: [],
            originalGroups: [],
            incompleteSheets: false,
            firstEntry: false,
            allProjects: [],
            projectIdToSummary: new Map(),
            projectsFilter: [],
            employeeMinHours: [],
            employeeMaxHours: [],
            prev1: undefined,
            isTourOpen: false,
            fromDateTimesheet: 0,
            toDateTimesheet: 253402300799,
            statusFilter: [],
            pendingTimesheets: 0,
            selectedTimesheetHasChanges: false,
            selectedNewTimesheet: undefined,
            openConfirmationModal: false,
            selectedItems: [] as any,
            errorMessage: "",
            showError: false,
            showBtnCreateTimeSheet: false,
            companyHoursManager: false,
            isRoleManager: false,
            isLoading: true,
            reload: 1,
            reloadProject: 0,
            fullReload: 0,
            forceRender: 0
        }
    }

    componentDidMount() {
        this.LoadComponent()
    }

    private LoadComponent = async () => {
        await this.loadEmployeeId()
        await this.fetchCompanyHoursManager()
        await this.countPendingTimesheets()
        this.setState({ isRoleManager: this.props.userProfile?.roles?.includes("Manager") })
        this.setState({ isLoading: false })
    }

    componentDidUpdate(prev: any) {
        const prevCompanyId = prev.notifications?.ActiveCompany
        //this.fetchCompanyHoursManager()
        if (this.state.companyId !== prevCompanyId) {
            this.fetchCompanyHoursManager()
        }
    }

    private getCurrencySymbol(currency: string) {
        switch (currency) {
            case "USD":
                return "$"
            case "EUR":
                return '\u20AC'
            case "BRL":
                return "R$"
            case "GBP":
                return '\u00A3'
            default:
                return '\u20AC'
        }
    }
    @autobind
    private selectedTimesheetHasChanges(changed: boolean) {
        this.setState({ selectedTimesheetHasChanges: changed })
    }


    @autobind
    private onTimesheetChange(items?: TimesheetItem[]) {
        if (items && items.length > 0) {
            let item = items[0]
            this.loadTimesheet(this.state.companyId!, item.employeeId, item.id)
            this.setState({ selectedItems: items })
        }
        else {
            this.setState({ timesheet: undefined, selectedItems: [] })
        }

    }


    @autobind
    private async loadEmployeeId() {
        var self = this
        this.setState({ isBusy: true })
        var companies = this.props.userProfile.companies
        if (!companies || companies.length == 0) {
            self.setState({
                isBusy: false,
                employeeId: undefined
            })
        } else {
            let currentCompanyGuid = this.props.cache.getGlobal("PMO-SELECTED-COMPANY")
            let currentCompany = currentCompanyGuid && companies.any(x => x.companyId == currentCompanyGuid) ? companies.filter((o: any) => o.companyId == currentCompanyGuid).first() : undefined
            if (!currentCompany)
                currentCompany = self.state.companyId == null ? companies[0] : companies.filter((o: any) => o.companyId == self.state.companyId)[0]
            self.setState({
                isBusy: false,
                companies: companies.map((o: any) => ({
                    id: o.companyId,
                    title: o.companyTitle,
                    employeeId: o.employeeId,
                    employeeTitle: o.employeeTitle,
                    isManager: o.isManager,
                    cirEligible: o.cirEligible,
                    ciiEligible: o.ciiEligible,
                    currency: o.currency,
                })),
                employeeId: currentCompany.employeeId,
                pendingTimesheets: 0,
                employeeTitle: currentCompany.employeeTitle,
                companyId: currentCompany.companyId,
                companyTitle: currentCompany.companyTitle,
                currency: this.getCurrencySymbol(currentCompany.currency),
                allowCir: currentCompany.cirEligible,
                allowCii: currentCompany.ciiEligible,
                canApproveTimesheets: currentCompany.isManager,
                isCompanyManager: currentCompany.isCompanyManager,
                hasRoleAdminOrManager: currentCompany.hasRoleAdminOrManager
            })
            await self.load(currentCompany.companyId!, currentCompany.employeeId)
        }

    }

    @autobind
    private async countPendingTimesheets() {
        var loading = this.state.isLoading
        if (!loading)
            this.setState({ isLoading: true })
        var count = 0
        var timesheets = this.state.timesheets
        if (this.state.canApproveTimesheets && this.state.hasRoleAdminOrManager) {
            var result = await this.httpService.get<number>(`${process.env.PUBLIC_URL}/api/v1/timesheet/${this.state.companyId}/${this.state.employeeId}/pending-timesheets-count`, {})
            var count = result.data
            this.setState({ pendingTimesheets: count })
        }
        if (!loading)
            this.setState({ isLoading: false })
    }
    @autobind
    private async load(companyId: string, employeeId: string, shouldReload: boolean = false) {
        this.setState({ isLoading: true })
        var self = this
        let currentTimesheet = this.state.timesheet
        notificationService.ChangeActiveCompany(companyId)
        notificationService.ChangeEmployee(employeeId)

        if (!currentTimesheet || currentTimesheet.employeeId != employeeId || shouldReload)
            currentTimesheet = undefined

        this.setState({ isLoading: false })
    }


    @autobind
    private async loadTimesheet(companyId: string, employeeId: string, timesheetId: string, error?: any) {
        var loading = this.state.isLoading
        if (!loading)
            this.setState({ isLoading: true })
        var self = this
        this.setState({ isBusy: true })


        await this.httpService.get<any>(`${process.env.PUBLIC_URL}/api/v1/timesheet/${companyId}/${employeeId}/${timesheetId}`).then(result => {
            let timesheet = {
                ...result.data,
                fromDate: moment(unixEpochToDate(result.data.fromDate)).toDate(),
                toDate: moment(unixEpochToDate(result.data.fromDate)).add('days', 6).toDate(),
                //toDate: unixEpochToDate(result.data.toDate)
            } as TimesheetItem

            timesheet.tasks.sort((a, b) => GetProjectTaskNames(a)[0].localeCompare(GetProjectTaskNames(b)[0]))


            self.setState({
                isBusy: false,
                error: error == null ? undefined : error,
                fromDateTimesheet: result.data.fromDate,
                toDateTimesheet: result.data.toDate,
                timesheet: timesheet,
            })

            this.setState({ employeeTitle: timesheet.employeeTitle })



        }).catch(error => {
            this.setState({ error: formatMessage(error), isBusy: false })
        })
        if (!loading)
            this.setState({ isLoading: false })
    }


    private fetchCompanyHoursManager = async () => {
        if (this.props.notifications?.ActiveCompany || this.state.companyId) {
            let param = this.props.notifications?.ActiveCompany || this.state.companyId
            timesheetsStore.setBaseUrl(param)
            try {
                const companyData = await timesheetsStore.getCompanyTimesheetManual(true)
                if (typeof companyData === 'boolean') {
                    const isUserManager = this.props.identity?.roles?.includes("Manager") || false
                    this.setState({ companyHoursManager: companyData, isRoleManager: isUserManager })
                }
            } catch (error) {
                console.error("Error fetching company data:", error)
            }
        }
    };

    @autobind
    private getUserHours() {
        var self = this
        this.setState({ isBusy: true })
        this.httpService.get<any>(`${process.env.PUBLIC_URL}/api/v1/companies/${this.state.companyId}/employees/${this.state.timesheet?.employeeId}`)
            .then(result => {
                const employee = result.data as EmployeeSummary
                let minHours = [
                    employee.mondayMinHours,
                    employee.tuesdayMinHours,
                    employee.wednesdayMinHours,
                    employee.thursdayMinHours,
                    employee.fridayMinHours
                ]
                let maxHours = [
                    employee.mondayMaxHours,
                    employee.tuesdayMaxHours,
                    employee.wednesdayMaxHours,
                    employee.thursdayMaxHours,
                    employee.fridayMaxHours
                ]
                self.setState({
                    isBusy: false,
                    error: undefined,
                    employeeMinHours: minHours,
                    employeeMaxHours: maxHours,
                    hasEmployeePlan: (minHours.sum(x => x) > 0) || (maxHours.sum(x => x) < 168)
                })
            })
            .catch(error => {
                this.setState({ error: formatMessage(error), isBusy: false })
            })
    }

    @autobind
    private async onSave(changes: TimesheetChange[]): Promise<boolean> {
        const { t } = this.props
        const itemList = this.state.selectedItems
        const lastItem = itemList[itemList.length - 1]

        try {
            if (lastItem && this.state.companyHoursManager && this.state.isRoleManager) {
                var result = await this.httpService.post<any, CommandResult<any>>(`${process.env.PUBLIC_URL}/api/v1/timesheet/${this.state.companyId}/${lastItem.employeeId}/${lastItem.id}/save`,
                    changes.map(o => ({ projectTaskId: o.rowKey, hours: o.value, day: o.colKey, notes: o.message, projectTaskTitle: o.taskTitle, projectTitle: o.projectTitle })))
                if (result.data.isSuccess) {
                    this.setState({ reload: this.state.reload + 1 })
                    this.loadTimesheet(this.state.companyId!, lastItem.employeeId, lastItem.id)
                    this.setState({ error: undefined, selectedTimesheetHasChanges: false })

                    this.countDownNotification(notification.success, t("Notification"), t("Operation completed successfully"), "success")
                    return true
                }
                else {
                    this.setState({ error: formatMessage(result.data) })
                    this.countDownNotification(notification.error, t("Error"), t("There was an error"), "error")
                    return false
                }
            } else {

                var result = await this.httpService.post<any, CommandResult<any>>(`${process.env.PUBLIC_URL}/api/v1/timesheet/${this.state.companyId}/${this.state.employeeId}/${this.state.timesheet!.id}/save`,
                    changes.map(o => ({ projectTaskId: o.rowKey, hours: o.value, day: o.colKey, notes: o.message, projectTaskTitle: o.taskTitle, projectTitle: o.projectTitle })))
                if (result.data.isSuccess) {
                    this.load(this.state.companyId!, this.state.employeeId!)
                    this.setState({ error: undefined })
                    this.countDownNotification(notification.success, t("Notification"), t("Operation completed successfully"), "success")
                    return true
                }
                else {
                    this.setState({ error: formatMessage(result.data) })
                    this.countDownNotification(notification.error, t("Error"), t("There was an error"), "error")
                    return false
                }
            }

        } catch (error) {
            this.setState({ error: formatMessage(error) })
            this.countDownNotification(notification.error, t("Error"), t("There was an error"), "error")
            return false
        }
    }

    @autobind
    private async onValidationHours(): Promise<boolean> {
        const { t } = this.props
        try {
            this.setState({ isBusy: true })
            await this.httpService.post<any, CommandResult<any>>(`${process.env.PUBLIC_URL}/api/v1/timesheet/${this.state.employeeId}/${this.state.timesheet!.id}/validationDeleteEmptyAndPublish`, {})
            this.setState({
                isBusy: false
            })
            return true
        } catch (error) {
            this.setState({ isBusy: false, error: formatMessage(error) })
            this.countDownNotification(notification.error, t("Error"), t("There was an error"), "error")
            return false
        }
    }

    @autobind
    private async onPublish(): Promise<boolean> {
        const { t } = this.props
        let timesheetId = this.state.timesheet!.id
        const selectedItems = this.state.selectedItems

        try {
            this.setState({ isBusy: true })

            if (selectedItems.length > 0) {
                for (let i = 0; i < selectedItems.length; i++) {
                    const currentItem = selectedItems[i]

                    await this.httpService.post<any, CommandResult<any>>(`${process.env.PUBLIC_URL}/api/v1/timesheet/${this.state.companyId}/${currentItem.employeeId}/${currentItem.id}/publish`,
                        {
                            link: `${window.location.origin}${process.env.PUBLIC_URL}/time-tracking/admin/companies/${this.state.companyId}/employees/${this.state.employeeId}/timesheets/${this.state.timesheet!.id}`
                        })
                    this.setState({
                        isBusy: false,
                        timesheet: { ...this.state.timesheet, status: 'Pending' } as TimesheetItem,
                        timesheets: this.state.timesheets.map(o => {
                            if (o.id == currentItem.id) {
                                o.status = 'Pending'
                            }
                            return o
                        }),
                        employeeId: currentItem.employeeId,
                        error: undefined, reload: this.state.reload + 1
                    }, () => this.countPendingTimesheets())

                    timesheetId = currentItem.id
                    selectedItems[i].status = 'Pending'
                }
                this.setState({ selectedItems: selectedItems })
            }
            else {
                await this.httpService.post<any, CommandResult<any>>(`${process.env.PUBLIC_URL}/api/v1/timesheet/${this.state.companyId}/${this.state.employeeId}/${this.state.timesheet!.id}/publish`,
                    {
                        link: `${window.location.origin}${process.env.PUBLIC_URL}/time-tracking/admin/companies/${this.state.companyId}/employees/${this.state.employeeId}/timesheets/${this.state.timesheet!.id}`
                    })
                this.setState({
                    isBusy: false,
                    timesheet: { ...this.state.timesheet, status: 'Pending' } as TimesheetItem,
                    timesheets: this.state.timesheets.map(o => {
                        if (o.id == this.state.timesheet!.id) {
                            o.status = 'Pending'
                        }
                        return o
                    }),
                    error: undefined, reload: this.state.reload + 1
                }, () => this.countPendingTimesheets())
            }

            this.loadTimesheet(this.state.companyId!, this.state.employeeId!, timesheetId)
            this.countDownNotification(notification.success, t("Notification"), t("Operation completed successfully"), "success")
            return true
        } catch (error) {
            this.setState({ isBusy: false, error: formatMessage(error) })
            this.countDownNotification(notification.error, t("Error"), t("There was an error"), "error")
            return false
        }
    }

    @autobind
    private customExpandIcon(props: any) {
        if (props.isActive) {
            return <a style={{ color: 'black' }} ><Icon type="close" /></a>
        } else {
            return <a style={{ color: 'black' }} ><Icon type="search" /></a>
        }
    }

    @autobind
    private openNotification(type: "success" | "error", text: string) {
        switch (type) {
            case "success":
                notification.success({
                    message: this.props.t("Success"),
                    description: this.props.t(text),
                })
                break
            case "error":
                notification.error({
                    message: this.props.t("Error"),
                    description: this.props.t(text),
                })
                break
            default:
                return
        }
    }

    @autobind
    private async onApprove(message: string): Promise<boolean> {
        const { t } = this.props
        return new Promise(async (resolve, reject) => {
            try {
                this.setState({ isBusy: true })

                const selectedItems = this.state.selectedItems

                if (selectedItems.length > 0) {
                    for (let i = 0; i < selectedItems.length; i++) {
                        const currentItem = selectedItems[i]
                        await this.sendApproveRequest(message, currentItem.employeeId, currentItem.id)
                        selectedItems[i].status = 'Approved'
                    }
                    resolve(true)
                }
                else {
                    this.setState({ errorMessage: t("Select at least one checkbox item"), showError: true })
                }

            } catch (error) {
                reject(error)
            } finally {
                this.setState({ isBusy: false, forceRender: this.state.forceRender + 1 })
            }
        })
    }

    private async sendApproveRequest(message: string, employeeId: string, timesheetId: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.setState({ isBusy: true })

            this.httpService.post<any, CommandResult<any>>(`${process.env.PUBLIC_URL}/api/v1/timesheet/${this.state.companyId}/${employeeId}/${timesheetId}/approve`,
                { statusMessage: message }).then(result => {
                    if (result.data.isSuccess) {
                        this.loadTimesheet(this.state.companyId!, employeeId, timesheetId).then(loadResult => {
                            this.updateTimesheetStatus(this.state.timesheet, "Approved")
                            this.setState({ error: undefined, reload: this.state.reload + 1 })
                            this.openNotification("success", "Successful action")
                            resolve(true)

                        })
                    } else {
                        reject(result.data.messages)
                    }
                }).catch(reason => {
                    this.setState({ isBusy: false, error: formatMessage(reason) })
                    reject(reason)
                })
        })
    }

    @autobind
    private async onReject(message: string): Promise<boolean> {
        const { t } = this.props
        return new Promise(async (resolve, reject) => {
            try {
                this.setState({ isBusy: true })

                const selectedItems = this.state.selectedItems

                if (selectedItems.length > 0) {
                    for (let i = 0; i < selectedItems.length; i++) {
                        const currentItem = selectedItems[i]
                        await this.sendRejectRequest(message, currentItem.employeeId, currentItem.id)
                        selectedItems[i].status = 'Rejected'
                    }
                    resolve(true)
                }
                else {
                    this.setState({ errorMessage: t("Select at least one checkbox item"), showError: true })
                }

            } catch (error) {
                reject(error)
            } finally {
                this.setState({ isBusy: false, forceRender: this.state.forceRender + 1 })
            }
        })
    }

    private async sendRejectRequest(message: string, employeeId: string, timesheetId: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.setState({ isBusy: true })
            this.httpService.post<any, CommandResult<any>>(`${process.env.PUBLIC_URL}/api/v1/timesheet/${this.state.companyId}/${employeeId}/${timesheetId}/reject`,
                { statusMessage: message }).then(result => {
                    if (result.data.isSuccess) {
                        this.loadTimesheet(this.state.companyId!, employeeId, timesheetId).then(loadResult => {
                            this.updateTimesheetStatus(this.state.timesheet, "Rejected")
                            this.setState({ error: undefined, reload: this.state.reload + 1 })
                            this.openNotification("success", "Successful action")
                            resolve(true)
                        })
                    } else {
                        reject(result.data.messages)
                    }
                }).catch(reason => {
                    this.setState({ isBusy: false, error: formatMessage(reason) })
                    reject(reason)
                })
        })
    }

    @autobind
    private async onRecall(): Promise<boolean> {
        const { t } = this.props
        return new Promise(async (resolve, reject) => {
            try {
                this.setState({ isBusy: true })

                const selectedItems = this.state.selectedItems

                if (selectedItems.length > 0) {
                    for (let i = 0; i < selectedItems.length; i++) {
                        const currentItem = selectedItems[i]
                        await this.sendRecallRequest(currentItem.employeeId, currentItem.id)
                        selectedItems[i].status = 'Draft'
                    }
                    this.setState({ selectedItems: selectedItems })
                    resolve(true)
                }
                else {
                    this.setState({ errorMessage: t("Select at least one checkbox item"), showError: true })
                }

            } catch (error) {
                reject(error)
            } finally {
                this.setState({ isBusy: false })
            }
        })
    }

    private async sendRecallRequest(employeeId: string, timesheetId: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.setState({ isBusy: true })
            this.httpService.post<any, CommandResult<any>>(`${process.env.PUBLIC_URL}/api/v1/timesheet/${this.state.companyId}/${employeeId}/${timesheetId}/recall`,
                {}).then(result => {
                    if (result.data.isSuccess) {
                        this.loadTimesheet(this.state.companyId!, employeeId, timesheetId).then(loadResult => {
                            this.updateTimesheetStatus(this.state.timesheet, "Draft")
                            this.setState({ error: undefined, reload: this.state.reload + 1 })
                            this.openNotification("success", "Successful action")
                            resolve(true)
                        })
                    } else {
                        reject(result.data.messages)
                    }
                }).catch(reason => {
                    this.setState({ isBusy: false, error: formatMessage(reason) })
                    reject(reason)
                })
        })
    }

    @autobind
    private updateTimesheetStatus(timesheet: TimesheetItem | undefined, newStatus: any) {
        if (timesheet === undefined)
            return

        let timesheets = [...this.state.timesheets]

        if (timesheets.length === 0) return

        timesheets.firstOrDefault(ts => ts.id == timesheet.id)!.status = newStatus
        this.setState({ timesheets: timesheets }, () => this.countPendingTimesheets())
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        })
        const timer = setInterval(() => {
            secondsToGo -= 1
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            })
        }, 1000)
        setTimeout(() => {
            clearInterval(timer)
            notification.close(key)
        }, secondsToGo * 1000)
    }

    @autobind
    private arrayDifference(array1: any[], array2: any[]) {
        var difference = array1.filter(x => array2.indexOf(x) === -1)
        return difference
    }

    @autobind
    private async onAddProjectTask(projectTask: TimesheetProjectMode) {
        const { t } = this.props
        const itemList = this.state.selectedItems
        const lastItem = itemList[itemList.length - 1]
        var success: any[] = []
        this.setState({ addNewTaskShown: false })
        const updateStateAndLoadTimesheet = async () => {
            const companyId = this.state.companyId!
            const employeeId = lastItem && this.state.companyHoursManager && this.state.isRoleManager ? lastItem.employeeId : this.state.employeeId!
            const timesheetId = lastItem ? lastItem.id : this.state.timesheet!.id
            await this.loadTimesheet(companyId, employeeId, timesheetId)
        }

        try {
            this.setState({ isBusy: true })

            if (projectTask && projectTask.projectTasks?.length > 0) {
                const result = await this.httpService.post<any, CommandResult<any>>(`${process.env.PUBLIC_URL}/api/v1/timesheet/${this.state.companyId}/${this.state.employeeId}/${this.state.timesheet!.id}/add/projectTasks`, projectTask)
                if (result.data) {
                    success.push(result.data)
                    this.countDownNotification(notification.success, t("Notification"), t("Operation completed successfully"), "success")
                    await updateStateAndLoadTimesheet()
                }
            } else {
                this.countDownNotification(notification.warning, t("Notification"), t("There are no tasks to assign the project"), "warning")
                this.setState({ isBusy: false })
                return
            }
        } catch (error) {
            this.setState({ isBusy: false, error: formatMessage(error) })
            this.countDownNotification(notification.error, t("Error"), t("There was an error"), "error")
        }

        this.setState({ reloadProject: this.state.reloadProject + 1 })
        this.props.handleResetSuccessAddTask && this.props.handleResetSuccessAddTask()

        return this.arrayDifference(projectTask.projectTasks, success)
    }

    @autobind
    private async onRemoveProjectTask(projectTaskId: string) {
        const itemList = this.state.selectedItems
        const lastItem = itemList[itemList.length - 1]
        try {
            this.setState({ isBusy: true })
            await this.httpService.delete<any, CommandResult<any>>(`${process.env.PUBLIC_URL}/api/v1/timesheet/${this.state.companyId}/${this.state.employeeId}/${this.state.timesheet!.id}/${projectTaskId}`, {})
            if (lastItem && this.state.companyHoursManager && this.state.isRoleManager) {
                this.setState({ isBusy: false }, () => this.loadTimesheet(this.state.companyId!, lastItem.employeeId, lastItem.id))
            } else {
                this.setState({ isBusy: false }, () => this.loadTimesheet(this.state.companyId!, this.state.employeeId!, this.state.timesheet!.id))
            }
        } catch (error) {
            this.setState({ isBusy: false, error: formatMessage(error) })
        }
    }

    @autobind
    private async onDownload(format?: string): Promise<boolean> {
        try {
            this.setState({ isBusy: true })
            var result = await this.httpService.get(`${process.env.PUBLIC_URL}/api/v1/timesheet/${this.state.companyId}/${this.state.employeeId}/${this.state.timesheet!.id}/export/${format}`, {
                responseType: 'arraybuffer'
            })
            this.setState({ isBusy: false })
            successNotification(this.props.t('Operation Completed Successfully'), this.props.t('Your operation will be processed in background.'))

            return true
        } catch (error) {
            this.setState({ isBusy: false, error: formatMessage(error) })
            return false
        }
    }
    @autobind
    private onDashboardChanged(dashboard: 'user-timesheet' | 'team-timesheets' | 'user-my-reports') {

        if (dashboard == 'user-timesheet') {
            this.props.history.push("/time-tracking/my-timesheet")
        }

        if (dashboard == 'user-my-reports') {

            this.props.history.push("/time-tracking/my-timesheet-report")
        }
    }

    @autobind
    private onCompanyChange(companyId: string) {
        var companies = this.props.userProfile.companies
        let currentCompany = companyId && companies.any(x => x.companyId == companyId) ? companies.filter((o: any) => o.companyId == companyId).first() : undefined
        if (!currentCompany)
            currentCompany = companyId == null ? companies[0] : companies.filter((o: any) => o.companyId == companyId)[0]
        this.props.cache.saveGlobal("PMO-SELECTED-COMPANY", companyId, { type: TimeType.Days, value: 9999999 })
        let authorized = currentCompany.isManager && currentCompany.hasRoleAdminOrManager;
        if (!authorized) this.state.selectedTimesheetHasChanges ? this.setState({ openConfirmationModal: true, selectedNewTimesheet: "user-timesheet" }) : this.onDashboardChanged("user-timesheet")
        else {
            this.setState({
                companyId: currentCompany.companyId,
                companyTitle: currentCompany.companyTitle,
                currency: this.getCurrencySymbol(currentCompany.currency),
                allowCir: currentCompany.cirEligible,
                allowCii: currentCompany.ciiEligible,
                employeeId: currentCompany.employeeId,
                employeeTitle: currentCompany.employeeTitle,
                periodFilter: [],
                projectsFilter: [],
                incompleteSheets: false,
                statusFilter: [],
                employeeFilter: '',
                employeesFilter: [],
                timesheet: undefined,
                canApproveTimesheets: currentCompany.isManager,
                hasRoleAdminOrManager: currentCompany.hasRoleAdminOrManager
            }, async () => {

                this.load(this.state.companyId!, this.state.employeeId!)
                this.setState({ reloadProject: this.state.reloadProject + 1 })
                this.setState({ fullReload: this.state.fullReload + 1 })

            })
        }
  }

  private getDefaultActiveKeyForInnerItem(id: string | undefined, groups: any, valueConditionFunc?: (item: any) => boolean) {
    if (valueConditionFunc === undefined) {
      valueConditionFunc = function (t: any): boolean { return t.id == id }
    }

    if (id && groups) {
      let key = groups.firstOrDefault((g: any) => {
        return g.items.any(valueConditionFunc)
      })
      if (key) {
        return key.id
      }
      return undefined
    }
  }

  private filterTimesheetsByStatus(timesheets: any[], filter: string[]) {
    if (filter.length > 0) {
      return timesheets.filter(item => filter.some(x => item.status === x))
    }
    return timesheets
  }

  private filterTimesheetsByEmployeeTitle(timesheets: TimesheetSummary[], filter: string[]): TimesheetSummary[] {
    if (filter.length > 0) {
      return timesheets.filter(item => filter.some(x => item.employeeTitle === x))
    }
    return timesheets
  }

  private groupByTimeSheets(timesheets: TimesheetSummary[]) {
    let groups = timesheets.groupBy(o => ({ year: o.fromDate.getUTCFullYear() })).map(group => {
      let innerGroups = group.items.groupBy(o => ({ month: o.fromDate.getUTCMonth() })).map(igroup => ({
        id: `${igroup.key.month}`,
        items: igroup.items.map(item => ({
          id: item.id,
          object: item
        })),
        object: {
          title: `${moment().month(igroup.key.month).lang("en").format("MMMM")}`
        }
      } as GroupData<any, TimesheetItem>))

      return {
        id: `${group.key.year}`,
        items: [{
          id: `${group.key.year}`,
          object: innerGroups
        }],
        object: {
          title: `${moment().year(group.key.year).format("YYYY")}`
        }
      } as GroupData<any, GroupData<any, TimesheetItem>[]>
    })
    return groups
  }






  @autobind
  private async onDeleteEmptyTasks() {
    const { t } = this.props
    const itemList = this.state.selectedItems
    const lastItem = itemList[itemList.length - 1]
    try {
      this.setState({ isBusy: true })
      await this.httpService.delete<any, CommandResult<any>>(`${process.env.PUBLIC_URL}/api/v1/timesheet/${this.state.employeeId}/${this.state.timesheet!.id}/deleteEmpty`, {})
      this.countDownNotification(notification.success, t("Notification"), t("Operation completed successfully"), "success")

      if (lastItem && this.state.companyHoursManager && this.state.isRoleManager) {
        await this.setState({ isBusy: false, addNewTaskShown: false }, () => this.loadTimesheet(this.state.companyId!, lastItem.employeeId, lastItem.id))
      } else {
        await this.setState({ isBusy: false }, () => this.loadTimesheet(this.state.companyId!, this.state.employeeId!, this.state.timesheet!.id))
      }
    } catch (error) {
      this.setState({ isBusy: false }, () => this.loadTimesheet(this.state.companyId!, this.state.employeeId!, this.state.timesheet!.id, formatMessage(error)))
      this.countDownNotification(notification.error, t("Error"), t("There was an error"), "fail")
    }
  }

  @autobind
  private async onDeleteBulk(items: string[]) {
    try {
      this.setState({ isBusy: true })
      const result = await this.httpService.delete<any, CommandResult<any>>(`${process.env.PUBLIC_URL}/api/v1/timesheet/${this.state.employeeId}/${this.state.timesheet!.id}/deleteBulk`, items)
      this.setState({ isBusy: false }, () => this.loadTimesheet(this.state.companyId!, this.state.employeeId!, this.state.timesheet!.id))
    } catch (error) {
      this.setState({ isBusy: false, error: formatMessage(error) })
    }
  }



  private taskComparer(t1: TimesheetTaskItem, t2: TimesheetTaskItem) {
    if ((t1.isFavorite && t2.isFavorite) || (!t1.isFavorite && !t2.isFavorite)) {
      var n1 = t1.title.toUpperCase()
      var n2 = t2.title.toUpperCase()
      return (n1 > n2) ? 1 : ((n1 < n2) ? -1 : 0)
    }
    return t1.isFavorite ? -1 : 1
  }

  @autobind
  private setIsTourOpen(state: boolean) {
    this.setState({ isTourOpen: state })
  }

  @autobind
  private disableBody(e: any) {
    disableBodyScroll(e.target)
  }

  @autobind
  private enableBody(e: any) {
    enableBodyScroll(e.target)
  }

  private extractNameFromFullName(fullName: any) {
    const nameAndEmail = fullName.match(/^(.*?)\s+\((.*)\)$/)

    if (nameAndEmail && nameAndEmail.length > 1 && nameAndEmail[1].trim() !== '') {
      return nameAndEmail[1].trim()
    }

    const nameInParentheses = fullName.match(/\((.*?)\)/)

    if (nameInParentheses && nameInParentheses.length > 1) {
      return nameInParentheses[1].trim()
    }

    return fullName.trim()
  }

  render() {
    const { t, i18n } = this.props
    if (this.state.companyId && this.state.timesheet?.employeeId) {
      if (this.state.prev1 != this.state.timesheet?.employeeId) {
        this.setState({ prev1: this.state.timesheet?.employeeId })
        this.getUserHours()
      }
    }
    if (!this.state.employeeId) {
      return <Empty description={t("There is no timesheet for you available yet. Please contact your manager.")} />
    }
    const sideSize = 390
    const { Panel } = Collapse
    const isFutureAllowed = this.props.userProfile.companies.firstOrDefault(x => x.companyId == this.state.companyId)?.isFutureAllowed || false
    const filterHeader = (<h5 style={{ marginTop: 6 }} >{t('Advanced search')} </h5>)
    let employeeTitle = this.extractNameFromFullName(this.state.employeeTitle)

    return <div style={{ marginTop: -20 }} data-tut="reactour__content">
      <Row gutter={0}>
        <Col span={12}>
          <Tour
            steps={steps(t).stepsMyTeam}
            isOpen={this.state.isTourOpen}
            onRequestClose={() => this.setIsTourOpen(false)}
            onAfterOpen={this.disableBody}
            onBeforeClose={this.enableBody}
          />
        </Col>
        <Col span={12}>

        </Col>
      </Row>
      <Row gutter={0}>
        <Col span={10}>
          <ContentTitle title={t("My team's timesheets")} type={this.state.companyTitle || ""} />
        </Col>
        <Col span={14} style={{ marginTop: 10 }}>
          <Row><Button data-tut="reactour__init" style={{ float: 'right' }} type={"link"} onClick={() => this.setIsTourOpen(true)} icon={'caret-right-fill'}>  {t("Discover My Team")} </Button></Row>
          <Row>
            <Dropdown
              trigger={['click']}
              placement={"bottomRight"}
              overlay={<Menu onClick={(param) => this.onCompanyChange(param.key)}>{this.state.companies.map(c => <Menu.Item key={c.id}>{c.title}</Menu.Item>)}</Menu>}>
              <Button style={{ minWidth: 120, float: 'right', textAlign: 'left', lineHeight: '30px' }}>{this.state.companyTitle}<Icon style={{ float: 'right', lineHeight: '32px' }} type={"down"} /></Button>
            </Dropdown>
            <Radio.Group style={{ float: 'right' }} onChange={(e) => this.state.selectedTimesheetHasChanges ? this.setState({ openConfirmationModal: true, selectedNewTimesheet: e.target.value }) : this.onDashboardChanged(e.target.value)} value={'team-timesheets'}>
              <Radio.Button key="user-timesheet" value="user-timesheet">{t("My timesheets")}</Radio.Button>

              {this.state.canApproveTimesheets && this.state.hasRoleAdminOrManager &&
                <Radio.Button style={{ background: "rgb(0,0,164)", cursor: "default", color: "white" }} key="team-timesheets" value="team-timesheets">
                  <EditableTooltip name="principal-myteam" iconColor="white">
                    <Badge offset={[20, -10]} count={this.state.pendingTimesheets}>{t("My team's timesheets")}</Badge>
                  </EditableTooltip>
                </Radio.Button>}

              <Radio.Button key="user-my-reports" value="user-my-reports">
                <span data-tut="reactour__myReports">
                  {t("My Reports")}
                </span>
              </Radio.Button>
            </Radio.Group>
          </Row>
        </Col>
      </Row>
      <Row type={'flex'} align='top' justify='space-between'>
        <Card style={{ width: '100%' }} className='timesheet'>
          {this.state.error && <Alert type='error' message={this.state.error} />}
          {this.state.showError &&
            <Alert
              type="error"
              message={this.state.errorMessage}
              closable
              onClose={() => this.setState({ showError: false })}
            />
          }
          <SplitterLayout primaryIndex={1} secondaryInitialSize={sideSize} secondaryMinSize={sideSize} customClassName='timesheet-splitter first-splitter'>
            <Spin size='large' spinning={this.state.isLoading}>
              <TimeSheetCalendar hasEmployeePlan={this.state.hasEmployeePlan} setError={(error: string) => this.setState({ errorMessage: error, showError: error.length > 0 })} isRoleManager={this.state.isRoleManager} companyHoursManager={this.state.companyHoursManager} fullReaload={this.state.fullReload} reload={this.state.reload} onSelectTimeSheet={(timesheets?: TimesheetItem[]) => { this.onTimesheetChange(timesheets) }} employeeId={this.state.employeeId} companyId={this.state.companyId} forceRender={this.state.forceRender} />
            </Spin>
            <Spin size='large' spinning={this.state.isLoading}>
              <div style={{ padding: 20 }}>
                {this.state.timesheet &&
                  <Timesheet
                    isFutureAllowed={isFutureAllowed}
                    employeeTitle={employeeTitle}
                    employeeId={this.state.timesheet.employeeId}
                    comapnyId={this.state.companyId!}
                    timesheetId={this.state.timesheet.id}
                    start={this.state.timesheet.fromDate}
                    end={this.state.timesheet.toDate}
                    minHours={this.state.timesheet.minHours}
                    maxHours={this.state.timesheet.maxHours}
                    canManage={this.props.identity && this.props.userProfile.roles &&
                      (this.props.userProfile.roles.includes("Manager") || this.props.userProfile.roles.includes("Administrator")
                        || this.props.userProfile.roles.includes("ClientAdmin"))}
                    status={this.state.timesheet.status}
                    onAddProjectTask={this.state.timesheet.status == 'Draft' ? () => this.setState({ addNewTaskShown: true }) : undefined}
                    onDeleteEmptyTask={this.onDeleteEmptyTasks}
                    onDeleteMultiple={(items: string[]) => this.onDeleteBulk(items)}
                    onRemoveProjectTask={this.onRemoveProjectTask}
                    onSave={this.onSave}
                    onValidationHours={this.onValidationHours}
                    onPublish={this.onPublish}
                    onRecall={this.onRecall}
                    onApprove={this.onApprove}
                    onReject={this.onReject}
                    onDownload={this.onDownload}
                    readonly={(this.state.companyHoursManager && this.state.isRoleManager) ? false : true}
                    rowsDataSource={{
                      title: t('Tasks'),
                      render: (item: any) => <span>{GetProjectTaskNames(item.object)[1]}</span>,
                      onSearch: (item: any, q: any) => (item.object.title && q) ? item.object.title.toUpperCase().includes(q.toUpperCase()) : false,
                      items: this.state.timesheet.tasks.sort(this.taskComparer).map(o => ({
                        rowKey: o.projectTaskId,
                        object: o,
                        projectTitle: GetProjectTaskNames(o as any)[0],
                        isFavorite: o.isFavorite,
                        projectTaskTitle: GetProjectTaskNames(o as any)[1],
                        projectId: o.projectId,
                        disabled: o.disabledForEmployee
                      }))
                    }}
                    cellsDataSource={{
                      items: this.state.timesheet.tasks.flatMap(task => task.entries.map(cell => ({ rowKey: task.projectTaskId, colKey: cell.day, referenceKey: task.projectId, value: cell.hours, optionalValue: cell.notes, object: cell, disabled: task.disabledForEmployee }))),
                      defaultValue: 0
                    }}
                    filteredProjects={this.state.projectsFilter}
                    projectIdToSummary={this.state.projectIdToSummary}
                    employeeMinHours={this.state.employeeMinHours}
                    employeeMaxHours={this.state.employeeMaxHours}
                    showFavorite={false}
                    selectedTimesheetHasChanges={this.selectedTimesheetHasChanges}
                    isManager={this.state.isRoleManager}
                    companyHoursManager={this.state.companyHoursManager}
                  />
                }
                {!this.state.timesheet && <Empty />}
              </div>
            </Spin>
          </SplitterLayout>
        </Card>
        <Modal
          visible={this.state.openConfirmationModal}
          closable={false}
          onOk={() => {
            this.setState({ openConfirmationModal: false, selectedTimesheetHasChanges: false }, () => this.onDashboardChanged(this.state.selectedNewTimesheet))
          }}
          onCancel={() => this.setState({ openConfirmationModal: false })}
          okText={t("Ok")}
          cancelText={t("Cancel")}
          title={t('Confirmation required')}>
          <div>
            <p>
              {t("You have pending changes to save. Do you want to continue?")}
            </p>
          </div>
        </Modal>
        {(this.state.addNewTaskShown && this.state.companyHoursManager && this.state.isRoleManager) && <AddNewTaskView
          t={t}
          onOk={this.onAddProjectTask}
          onCancel={() => this.setState({ addNewTaskShown: false })}
          companyId={this.state.companyId}
          employeeId={this.state.employeeId}
          canAddNewProjectsTask={!this.state.hasRoleAdminOrManager || this.state.hasRoleAdminOrManager}
          isOnlyUser={!this.state.hasRoleAdminOrManager}
          fromDate={this.state.fromDateTimesheet}
          toDate={this.state.toDateTimesheet}
          companyAllowCir={this.state.allowCir}
          companyAllowCii={this.state.allowCii}
        />}
      </Row>

    </div>
  }
}
export default withRouter(withUserProfile(withCache(withNotification(withIdentity(withTranslation()(windowSize(TimesheetPage)) as any) as any) as any) as any) as any) as any as React.ComponentClass<TimesheetPageProps>